import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import "./PageNotFound.css";
import { Image, Spinner } from "react-bootstrap";
import HomePageIcon from "./HomePageIcon.png";
import SEO from "../../SEO";

const LoadingSpinner = () => {
  return (
    <Spinner animation="border" role="status">
      <span className="visually-hidden">Loading...</span>
    </Spinner>
  );
};

const PageNotFound = () => {
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(true);

  const handleGoHome = () => {
    navigate("/");
  };

  useEffect(() => {
    // Simulate a network check
    const timer = setTimeout(() => {
      setIsLoading(false); // Set loading to false after 2 seconds
    }, 100);

    return () => clearTimeout(timer);
  }, []);

  return (
    <div className="not-found-container">
      <SEO
        title="Page Not Found"
        description="Experience the best massage and therapy treatments at ShriKrishnaArogyam."
        keywords="spa, massage, therapy, wellness"
      />
      {isLoading ? (
        <LoadingSpinner />
      ) : (
        <>
          <Image
            src={HomePageIcon}
            alt="Go Home"
            className="HomePageIcon"
            onClick={handleGoHome}
          />
        </>
      )}
    </div>
  );
};

export default PageNotFound;
